export default __webpack_public_path__ + "c7899fa388e8c736a37805d3ca98595f.png";